<template>
    <v-form @submit.prevent="$emit('submit')" :disabled="processForm">
        <v-row>
            <v-col cols="12">
                <v-alert type="error" v-model="alertError" dismissible ref="mensajeError">
                    <ul v-for="(errors, index) in listErrors" :key="index">
                        <li v-text="errors[0]"></li>
                    </ul>
                </v-alert>
            </v-col>

            <!-- Información General -->
            <v-col cols="12">
                <v-card class="mb-4">
                    <v-card-title class="subtitle-1 font-weight-bold">Información General</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    dense
                                    label="URL Path (*)"
                                    v-model="formModel.url_path"
                                    prefix="https://optimania.pe/"
                                    prefix-backgraund="primary"
                                    placeholder="exmple-url-path"
                                    @input="handleInputUrlPath"
                                    :error-messages="errorMessages.url_path"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    dense
                                    label="Título (*)"
                                    v-model="formModel.title"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select
                                    dense
                                    item-text="texto"
                                    item-value="valor"
                                    :items="cmbEstado"
                                    label="Estado(*)"
                                    outlined
                                    v-model="formModel.estado"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- SEO -->
            <v-col cols="12">
                <v-card class="mb-4">
                    <v-card-title class="subtitle-1 font-weight-bold">SEO</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field
                                    dense
                                    label="SEO Título"
                                    v-model="formModel.seo_title"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-textarea
                                    dense
                                    label="SEO Descripción"
                                    v-model="formModel.seo_description"
                                    rows="3"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-img v-if="seoImagePreview" :src="seoImagePreview" max-height="150" contain></v-img>
                                <v-file-input
                                    v-model="formModel.seo_image"
                                    label="SEO Imagen"
                                    accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                                    prepend-icon="mdi-camera"
                                    @change="previewSeoImage"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- Banner -->
            <v-col cols="12">
                <v-card class="mb-4">
                    <v-card-title class="subtitle-1 font-weight-bold">Banner</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field
                                    dense
                                    label="Título del Banner"
                                    v-model="formModel.banner_title"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-textarea
                                    dense
                                    label="Descripción del Banner"
                                    v-model="formModel.banner_description"
                                    rows="3"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-img
                                    v-if="bannerImagePreview"
                                    :src="bannerImagePreview"
                                    max-height="150"
                                    contain
                                ></v-img>
                                <v-file-input
                                    v-model="formModel.banner_image"
                                    label="Imagen del Banner"
                                    accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                                    prepend-icon="mdi-camera"
                                    @change="previewBannerImage"
                                ></v-file-input>
                                <v-text-field
                                    dense
                                    label="Nombre de la Imagen del Banner"
                                    v-model="formModel.banner_image_name"
                                    @input="handleInputBannerImageName"
                                    :error-messages="errorMessages.banner_image_name"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-img
                                    v-if="bannerMobileImagePreview"
                                    :src="bannerMobileImagePreview"
                                    max-height="150"
                                    contain
                                ></v-img>
                                <v-file-input
                                    v-model="formModel.banner_image_mobil"
                                    label="Imagen del Banner (Móvil)"
                                    accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                                    prepend-icon="mdi-camera"
                                    @change="previewBannerMobileImage"
                                ></v-file-input>
                                <v-text-field
                                    dense
                                    label="Nombre de la Imagen del Banner (Móvil)"
                                    v-model="formModel.banner_image_mobil_name"
                                    @input="handleInputBannerMobileImageName"
                                    :error-messages="errorMessages.banner_image_mobil_name"
                                    counter="250"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" class="text-center">
                <v-btn class="mr-2" type="submit" :loading="processForm" color="success" large>
                    <v-icon left large>mdi-content-save</v-icon>
                    GUARDAR
                </v-btn>
                <v-btn
                    :to="{ name: 'pageDataCatalogPanel.index' }"
                    type="button"
                    :loading="processForm"
                    color="error"
                    large
                >
                    <v-icon left large>mdi-close</v-icon>
                    CANCELAR
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
    export default {
        name: 'FormPageDataCatalog',
        props: {
            value: {
                type: Object,
                required: true,
                default: () => ({
                    url_path: '',
                    title: '',
                    seo_title: '',
                    seo_description: '',
                    seo_image: null,
                    banner_title: '',
                    banner_description: '',
                    banner_image_name: '',
                    banner_image_mobil_name: '',
                    banner_image: null,
                    banner_image_mobil: null,
                    estado: 1,
                }),
            },
            processForm: {
                type: Boolean,
                default: false,
            },
            alertError: {
                type: Boolean,
                default: false,
            },
            listErrors: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                formModel: { ...this.value },
                cmbEstado: [
                    { texto: 'Habilitado', valor: 1 },
                    { texto: 'Inhabilitado', valor: 0 },
                ],
                seoImagePreview: this.value.seo_image_url || null,
                bannerImagePreview: this.value.banner_image_url || null,
                bannerMobileImagePreview: this.value.banner_image_mobil_url || null,
                errorMessages: {
                    url_path: [],
                    banner_image_name: [],
                    banner_image_mobil_name: [],
                },
            };
        },
        watch: {
            value: {
                handler(newVal) {
                    if (JSON.stringify(this.formModel) !== JSON.stringify(newVal)) {
                        this.formModel = newVal;
                        this.$nextTick(() => {
                            this.seoImagePreview = this.value.seo_image_url || null;
                            this.bannerImagePreview = this.value.banner_image_url || null;
                            this.bannerMobileImagePreview = this.value.banner_image_mobil_url || null;
                        });
                    }
                },
                deep: true,
            },
            formModel: {
                handler(newVal) {
                    if (JSON.stringify(this.value) !== JSON.stringify(newVal)) {
                        this.$emit('input', newVal);
                    }
                },
                deep: true,
            },
        },
        methods: {
            validateUrlPath(val) {
                const urlPath = val;
                if (urlPath) {
                    const regex = /^[a-z0-9-/]+$/;
                    return regex.test(urlPath);
                }
                return true;
            },
            validateImageName(val) {
                if (val) {
                    const regex = /^[a-zA-Z0-9-]+$/;
                    return regex.test(val);
                }
                return true;
            },
            handleInputUrlPath(newVal) {
                this.errorMessages.url_path = [];
                if (!this.validateUrlPath(newVal)) {
                    this.errorMessages.url_path.push(
                        'La URL Path debe contener solo letras minúsculas, números y guiones.'
                    );
                }
            },
            handleInputBannerImageName(newVal) {
                this.errorMessages.banner_image_name = [];
                if (!this.validateImageName(newVal)) {
                    this.errorMessages.banner_image_name.push(
                        'El nombre solo puede contener letras, números y guiones.'
                    );
                }
            },
            handleInputBannerMobileImageName(newVal) {
                this.errorMessages.banner_image_mobil_name = [];
                if (!this.validateImageName(newVal)) {
                    this.errorMessages.banner_image_mobil_name.push(
                        'El nombre solo puede contener letras, números y guiones.'
                    );
                }
            },
            previewSeoImage(file) {
                if (file) {
                    this.seoImagePreview = URL.createObjectURL(file);
                } else {
                    this.seoImagePreview = this.value.seo_image_url || null;
                }
            },
            previewBannerImage(file) {
                if (file) {
                    this.bannerImagePreview = URL.createObjectURL(file);
                    this.formModel.banner_image_name = this.formModel.banner_image_name
                        ? this.formModel.banner_image_name
                        : file.name;
                } else {
                    this.bannerImagePreview = this.value.banner_image_url || null;
                }
            },
            previewBannerMobileImage(file) {
                if (file) {
                    this.bannerMobileImagePreview = URL.createObjectURL(file);
                    this.formModel.banner_image_mobil_name = this.formModel.banner_image_mobil_name
                        ? this.formModel.banner_image_mobil_name
                        : file.name;
                } else {
                    this.bannerMobileImagePreview = this.value.banner_image_mobil_url || null;
                }
            },
        },
    };
</script>
